<span [class.text-placeholder]="!orderLine">{{ name }}</span>
